import { gql } from "graphql-tag";

export const GET_ABILITIES = gql`
  query {
    abilities
  }
`;


export default { GET_ABILITIES }